
!(function n(i, o, a) {
    function c(r, e) {
        if (!o[r]) {
            if (!i[r]) {
                var t = "function" == typeof require && require;
                if (!e && t) return t(r, !0);
                if (s) return s(r, !0);
                throw (((t = new Error("Cannot find module '" + r + "'")).code = "MODULE_NOT_FOUND"), t);
            }
            (t = o[r] = { exports: {} }),
                i[r][0].call(
                    t.exports,
                    function (e) {
                        return c(i[r][1][e] || e);
                    },
                    t,
                    t.exports,
                    n,
                    i,
                    o,
                    a
                );
        }
        return o[r].exports;
    }
    for (var s = "function" == typeof require && require, e = 0; e < a.length; e++) c(a[e]);
    return c;
})(
    {
        1: [
            function (e, r, t) {
                "use strict";
                function n(e) {
                    return (n =
                        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                            ? function (e) {
                                return typeof e;
                            }
                            : function (e) {
                                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                            })(e);
                }
                function o(r, e) {
                    var t,
                        n = Object.keys(r);
                    return (
                        Object.getOwnPropertySymbols &&
                        ((t = Object.getOwnPropertySymbols(r)),
                            e &&
                            (t = t.filter(function (e) {
                                return Object.getOwnPropertyDescriptor(r, e).enumerable;
                            })),
                            n.push.apply(n, t)),
                        n
                    );
                }
                function a(n) {
                    for (var e = 1; e < arguments.length; e++) {
                        var i = null != arguments[e] ? arguments[e] : {};
                        e % 2
                            ? o(Object(i), !0).forEach(function (e) {
                                var r, t;
                                (r = n), (e = i[(t = e)]), (t = c(t)) in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : (r[t] = e);
                            })
                            : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(i))
                                : o(Object(i)).forEach(function (e) {
                                    Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(i, e));
                                });
                    }
                    return n;
                }
                function i(e, r) {
                    for (var t = 0; t < r.length; t++) {
                        var n = r[t];
                        (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, c(n.key), n);
                    }
                }
                function c(e) {
                    e = (function (e, r) {
                        if ("object" !== n(e) || null === e) return e;
                        var t = e[Symbol.toPrimitive];
                        if (void 0 === t) return ("string" === r ? String : Number)(e);
                        r = t.call(e, r || "default");
                        if ("object" !== n(r)) return r;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    })(e, "string");
                    return "symbol" === n(e) ? e : String(e);
                }
                window.HMSPowerReviews = (function () {
                    function e() {
                        !(function (e, r) {
                            if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
                        })(this, e),
                            (this.reviewsToRender = []),
                            this.init();
                    }
                    var r, t, n;
                    return (
                        (r = e),
                        (t = [
                            {
                                key: "renderReviews",
                                value: function (e) {
                                    var r = e.data("pageid"),
                                        t = e.attr("id"),
                                        n = {},
                                        i =
                                        {
                                            locale: reviews.locale,
                                            merchant_group_id:
                                                reviews.merchantGroupId,
                                            merchant_id: reviews.merchantId,
                                            api_key: reviews.apiKey,
                                            page_id: r,
                                            subject: {
                                                "@context": "https://schema.org",
                                                "@type": "Product",
                                                id: reviews.reviewCurrentUrl,
                                                name: reviews.reviewProductName,
                                                description: reviews.reviewDescription,
                                                image: reviews.reviewImgUrl,
                                                sku: reviews.reviewSku,
                                                brand: "Professional"
                                            },
                                        components: n
                                        };
                                    switch (e.data("reviewtype")) {
                                        case "ReviewForm":
                                            (n.Write = t), POWERREVIEWS.display.render(i);
                                            break;
                                        case "Category":
                                            (n.CategorySnippet = t), this.reviewsToRender.push(a(a({}, i), {}, { ENABLE_CLIENT_SIDE_STRUCTURED_DATA: !1 }));
                                            break;
                                        case "ReviewDisplay":
                                            (n.ReviewDisplay = t), (i.REVIEW_DISPLAY_SNAPSHOT_TYPE = "SIMPLE"), this.reviewsToRender.push(i);
                                            break;
                                        case "Review":
                                            (n.ReviewSnippet = t), this.reviewsToRender.push(i);
                                    }
                                },
                            },
                            {
                                key: "checkReviewByPageId",
                                value: function (e, t) {
                                    var n = e.data("pageid"),
                                        i = e.attr("id"),
                                        o = !1;
                                    $(this.reviewsToRender).each(function (e, r) {
                                        o ||
                                            (r.page_id === n &&
                                                (r.components.ReviewSnippet || r.components.ReviewDisplay) &&
                                                ("Review" === t ? (r.components.ReviewSnippet = i) : "ReviewDisplay" === t && ((r.components.ReviewDisplay = i), (r.REVIEW_DISPLAY_SNAPSHOT_TYPE = "SIMPLE")), (o = !0)));
                                    }),
                                        o || this.renderReviews(e);
                                },
                            },
                            {
                                key: "setupTracking",
                                value: function (e) {
                                    var r, t, n, i;
                                    POWERREVIEWS.tracker &&
                                        ((r = String(e.data("pageid"))),
                                            (t = e.data("sampleitemname").split("|")),
                                            (i = POWERREVIEWS.tracker.createTracker({ merchantGroupId: reviews.merchantGroupId })),
                                            (n = []),
                                            $(r.split(",")).each(function (e, r) {
                                                n.push({ page_id: r, product_name: t.length > e ? t[e] : "", quantity: 1, unit_price: 1 });
                                            }),
                                            i.trackCheckout({
                                                merchantGroupId: reviews.merchantGroupId,
                                                merchantId: reviews.merchantId,
                                                locale: reviews.locale,
                                                marketingOptIn: ("true" === (i = "string" == typeof (i = e.data("futureoptin")) ? i.toLowerCase() : i) ? (i = !0) : "false" === i && (i = !1), i),
                                                userEmail: e.data("email"),
                                                merchantUserId: e.data("email"),
                                                userFirstName: e.data("firstname") || "",
                                                userLastName: e.data("lastname"),
                                                orderId: e.data("orderid"),
                                                orderItems: n,
                                            }));
                                },
                            },
                            {
                                key: "init",
                                value: function () {
                                    var i = this;
                                    try {
                                        this.reviewsToRender.length = 0;
                                        var e = $(".js-review");
                                        e.length &&
                                            (e.each(function (e, r) {
                                                var t = $(r),
                                                    n = t.data("reviewtype");
                                                switch (n) {
                                                    case "CheckoutBeacon":
                                                        i.setupTracking(t);
                                                        break;
                                                    case "Category":
                                                    case "ReviewForm":
                                                        i.renderReviews(t);
                                                        break;
                                                    case "ReviewDisplay":
                                                    case "Review":
                                                        i.checkReviewByPageId(t, n);
                                                }
                                            }),
                                                this.reviewsToRender.length &&
                                                ((window.pwr =
                                                    window.pwr ||
                                                    function () {
                                                        (window.pwr.q = window.pwr.q || []).push(arguments);
                                                    }),
                                                    window.pwr("render", this.reviewsToRender)));
                                    } catch (e) {
                                        window.console && window.console.error && window.console.error(e);
                                    }
                                },
                            },
                        ]) && i(r.prototype, t),
                        n && i(r, n),
                        Object.defineProperty(r, "prototype", { writable: !1 }),
                        e
                    );
                })();
            },
            {},
        ],
    },
    {},
    [1]
);
